import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";
import {defineAsyncComponent} from "vue";
import { customAsyncComponent } from "@/functions/customAsyncComponent";
import { LOCALE_CATEGORIES } from "@/assets/locales/categories";
import { PageHeaderConfig } from "@/components/navigation/usePageHeader";
import { i18n } from "@/i18n";
import router from "@/router";
import { WorkspaceId } from "@/sdk";

export function getGroupToolsRouteRecord():RouteRecordRaw{
  return {
    name: 'group-tools',
    path: '/workspace/:workspaceId/group-tools',
    component: customAsyncComponent(async () => import('./views/GroupToolsView.vue')),
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.GROUP_TOOLS
      ]
    }
  }
}

export function getGroupToolsRouteLocation(workspaceId: number):RouteLocationRaw{
  return { name: 'group-tools', params:{workspaceId} }
}

export function getGroupToolsRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getGroupToolsPageHeaderConfig(): PageHeaderConfig{
  return {
    showHome: false,
    showTitle: false,
    title: '',
    breadcrumb: []
  }
}